"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionConfig_1 = require("../../../../../../../shared/components/table_actions/TableActionConfig");
var TableMenuIsDefault_1 = require("../../../../../../../shared/components/table_menus/TableMenuIsDefault");
var TableActionEdit_1 = require("../../../../../../../shared/components/table_actions/TableActionEdit");
var TableActionCopy_1 = require("../../../../../../../shared/components/table_actions/TableActionCopy");
var BonusTemplateCurrencyConfigList = /** @class */ (function (_super) {
    __extends(BonusTemplateCurrencyConfigList, _super);
    function BonusTemplateCurrencyConfigList(props) {
        return _super.call(this, props) || this;
    }
    BonusTemplateCurrencyConfigList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                currency_filter: data.currency_filter
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            currency_filter: this.props.data.DATA.currency_filter,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
        this.props.state.setExtBreadCrumbPath(["\u0412\u0430\u043B\u044E\u0442\u044B \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432 \u0431\u043E\u043D\u0443\u0441\u0430 - [" + this.props.rootRecord.title + "]"]);
    };
    BonusTemplateCurrencyConfigList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BonusTemplateCurrencyConfigList.prototype.doDefaultAction = function (Key, Title, isDefault) {
        var _this = this;
        this.props.data.SetIsDefault(Key, isDefault, function () {
            if (isDefault) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0412\u0430\u043B\u044E\u0442\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u043F\u043E\u043C\u0435\u0447\u0435\u043D \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C \u043F\u043E-\u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0412\u0430\u043B\u044E\u0442\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u043F\u043E\u043C\u0435\u0447\u0435\u043D \u043D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u043C \u043F\u043E-\u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E"));
            }
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    BonusTemplateCurrencyConfigList.prototype.getColumns = function () {
        var _this = this;
        return [{
                title: 'Бонус',
                dataIndex: this.props.data.dk_key,
                key: this.props.data.dk_key,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.rootRecord.title));
                }
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_title,
                key: this.props.data.dk_app_currency_title,
                width: 100,
                align: "center",
                filters: this.state.currency_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.app_currency_title.includes(value); },
            }, {
                title: 'По-умолчанию',
                dataIndex: this.props.data.dk_is_default,
                key: this.props.data.dk_is_default,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDefault_1.default, { defaultTexts: { menu: "Пометить валютой по-умолчанию", text: "Да" }, notDefaultTexts: { menu: "Снять пометку по-умолчанию", text: "Нет" }, record: { key: record.key, title: record.app_currency_title, isDefault: record.is_default }, onDefaultClick: _this.doDefaultAction.bind(_this) }));
                },
                width: 100,
            }, {
                title: 'Изменен',
                dataIndex: this.props.data.dk_date_changed,
                key: this.props.data.dk_date_changed,
                align: "center",
                width: 100,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Описание',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigBonusClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditBonusClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }),
                    React.createElement(TableActionCopy_1.default, { hint: "Клонировать", confirmText: "\u041A\u043B\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onCloneData(record); } }))); },
                width: 100
            }
        ];
    };
    BonusTemplateCurrencyConfigList.prototype.onCloneData = function (record) {
        var _this = this;
        this.props.dlgSelectKeyVal.SetTitle("Клонировать настройки")
            .SetOnCloseClick(function () { _this.props.dlgSelectKeyVal.Close(); })
            .SetViewData(this.props.availCurrency)
            .SetOnSelectClick(function (key, value) {
            _this.props.data.doCloneData(record.key, key, function () {
                if (!_this.props.dlgSelectKeyVal.DATA.notAutoCloseDialog) {
                    _this.props.dlgSelectKeyVal.Close();
                    _this.props.data.LoadData(_this.props.rootRecord.key);
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0431\u043E\u043D\u0443\u0441\u0430 \u043A\u043B\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u044B !"));
                }
            });
        }).Show();
    };
    BonusTemplateCurrencyConfigList.prototype.onConfigBonusClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    BonusTemplateCurrencyConfigList.prototype.onEditBonusClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BonusTemplateCurrencyConfigList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    BonusTemplateCurrencyConfigList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBack) {
                this.props.onGoBack();
            }
        }
    };
    BonusTemplateCurrencyConfigList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    defaultPageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] ")));
                } })));
    };
    return BonusTemplateCurrencyConfigList;
}(React.Component));
exports.default = BonusTemplateCurrencyConfigList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/currency_config/BonusTemplateCurrencyConfigsList.tsx
// module id = 1915
// module chunks = 0